import type { ReactNode } from 'react';
import { BrowserFrame } from './BrowserFrame.tsx';

/**
 * A product screen shown in a browser-window frame. Thin wrapper over
 * BrowserFrame so the product articles and the hero showcase share one frame.
 */
export function SpecimenPlate({
  host,
  children,
}: {
  host: string;
  children: ReactNode;
}): JSX.Element {
  return <BrowserFrame host={host}>{children}</BrowserFrame>;
}
